import { render, staticRenderFns } from "./smsGetMobile.vue?vue&type=template&id=2208b131&scoped=true&"
import script from "./smsGetMobile.vue?vue&type=script&lang=js&"
export * from "./smsGetMobile.vue?vue&type=script&lang=js&"
import style0 from "./smsGetMobile.vue?vue&type=style&index=0&id=2208b131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208b131",
  null
  
)

export default component.exports